import { ToggleLeft, ToggleRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/flowly/infra/Button/Button";
import { cn } from "@/lib/utils";

interface ReferenceToggleProps {
  useReferenceImages: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function ReferenceToggle({ useReferenceImages, onToggle, disabled = false }: ReferenceToggleProps) {
  const { t } = useLanguage();

  return (
    <div className="flex items-center ltr:justify-end rtl:justify-start gap-2 mb-2 mt-2">
      <span className={cn("text-xs text-muted-foreground", disabled && "opacity-50")}>
        {t.director.useReferenceImages}
      </span>
      <Button
        variant={useReferenceImages ? "primary" : "secondary"}
        size="xs"
        onClick={onToggle}
        disabled={disabled}
      >
        {useReferenceImages ? (
          <>
            <ToggleRight className="w-4 h-4" />
            {t.director.referenceOn}
          </>
        ) : (
          <>
            <ToggleLeft className="w-4 h-4" />
            {t.director.referenceOff}
          </>
        )}
      </Button>
    </div>
  );
}
